export default {
  "nav.thesis": "テーゼ",
  "nav.disciplines": "領域",
  "nav.horizon": "展望",
  "nav.join": "応募する",
  "nav.backus": "購読する",
  "nav.invest": "支援する",

  "hero.badge": "長寿をエンジニアリングする",
  "hero.l1": "人類の不死は理論上の話です。",
  "hero.l2": "150年は実現可能です。",
  "hero.sub": "長寿は多分野にまたがる人類の課題です。医学と健康科学は長寿における目覚ましい進歩を牽引してきました。次のブレイクスルーは、これらが工学、AI、神経学、心理学、認知科学、量子力学、素粒子物理学、時空と収束することから生まれるかもしれません。",
  "hero.sub2": "The Lifespan Projectはこれらの分野を結びつけます。既知の物理法則のどこにも、はるかに長い人間の寿命を禁じるものはないようです。私たちは何が可能かを探究し、証明するつもりです。",
  "hero.cta1": "プロジェクトに登録",
  "hero.cta2": "テーゼを読む",
  "hero.stats1": "09 領域",
  "hero.stats2": "サブリミナル・スケール",
  "hero.stats3": "初のソリューション ≤ 24か月",
  "hero.caption": "サブリミナル・スケールの研究が進行中",

  "mq.1": "時空",
  "mq.2": "素粒子物理学",
  "mq.3": "量子力学",
  "mq.4": "AIコンピューティング",
  "mq.5": "生物学",
  "mq.6": "神経学",
  "mq.7": "心理学",
  "mq.8": "認知科学",
  "mq.11": "健康科学",
  "mq.12": "医学",
  "mq.9": "長寿",
  "mq.10": "150年以上",

  "mani.eyebrow": "マニフェスト",
  "mani.h2a": "死は物理学で最も古い",
  "mani.h2b": "未解決問題",
  "mani.h2c": "です。",
  "mani.c1t": "テーゼ",
  "mani.c1b": "老化は自然法則ではありません。それは未解決の工学問題です。私たちは、人類が理論上は不死を、実用上は150年を超える寿命を、近い将来に実現できると確信しています。私たちが触れるすべての領域が同じ方向を指しています。",
  "mani.c2t": "メソッド",
  "mani.c2b": "私たちの研究・計算プログラムはサブリミナル・スケールで動いています。ノイズの下、物質と心の全層にわたって。素粒子の相互作用から神経計算まで、生命を理解し、シミュレーションし、延長できるシステムとしてモデル化しています。",
  "mani.c3t": "展望",
  "mani.c3b": "これは一世紀がかりの計画ではありません。今後2年以内に最初のソリューションを公開します。それは、はるかに大きなプログラムの最初の産物です。その先は複利で拡大します。",
  "mani.c4t": "モデル",
  "mani.c4b": "私たちの研究は広範なエコシステムによって支えられています。支援者、投資家、アカデミック購読者、慈善家、富裕層、起業家、協力企業、スポンサー。製品とサービスは The Lifespan Labs を通じて研究を動かし続けます。それらはエンジンであり、目的ではありません。",

  "disc.eyebrow": "スタック",
  "disc.h2a": "9つの領域。",
  "disc.more": "どう収束するか",
  "disc.converge": "医学 × 物理学 × 長寿",
  "disc.h2b": "1つの変数。",
  "disc.sub": "長寿は生物学だけの問題ではありません。素粒子から意識まで、フルスタックの問題です。",
  "disc.d1n": "時空と物質",
  "disc.d1d": "生命は物理的な構造の中で展開します。物質が時間を超えてどう組織化し、持続し、修復されるかを研究しています。",
  "disc.d1x": "医学は老化を年数で測りますが、物理学は時間そのものを問います。物質が時空の中でどう組織化され持続するかを研究し、生体システムが崩壊に抗うための最も深いレバーを探ります。",
  "disc.d2n": "素粒子物理学",
  "disc.d2d": "最小のスケールにこそ、他のすべてが従う法則があります。",
  "disc.d2x": "あらゆる薬、細胞、思考は、精密な規則に従う粒子でできています。最小スケールでその規則を理解することで、医学は近似ではなく原子レベルの精度で介入を設計できます。",
  "disc.d3n": "量子力学",
  "disc.d3d": "コヒーレンス、デコヒーレンス、そして生物機構の量子的基盤。",
  "disc.d3x": "生命はすでに量子的な仕組みで動いています。酵素、光合成、そしておそらく認知も。医学と量子物理学が交わる場所で、コヒーレンス、トンネル効果、センシングを、生物学を読み解き修復する新しい道具として探究します。",
  "disc.d4n": "AIとコンピューティング",
  "disc.d4d": "シミュレーションと機械知能が、数十年分の生物学的試行を数日の計算に圧縮します。",
  "disc.d4x": "AIは何十年もの医学的試行錯誤を数日のシミュレーションに圧縮します。身体の物理モデルと組み合わせることで、分子や治療法を患者に届ける前にin silicoで検証できます。",
  "disc.d5n": "生物学",
  "disc.d5d": "細胞修復、老化、再生。寿命を直接動かすレバーです。",
  "disc.d5x": "生物学は医学に標的を与えます。細胞修復、老化、再生。物理学水準の計測と組み合わせれば、老化は謎から工学仕様へと変わります。",
  "disc.d6n": "神経学",
  "disc.d6d": "脳はかけがえのない中核です。それを守り、延ばすことに妥協はありません。",
  "disc.d6x": "脳は、医学がまだ失われた機能を置き換えられない場所です。神経学は物理学やコンピューティングと収束し、私たちの本質という代替不可能な核を守り、接続し、いつか拡張します。",
  "disc.d7n": "心理学と認知科学",
  "disc.d7d": "長い人生は、生きる価値のある人生であり続けなければなりません。心、記憶、意味も含めて。",
  "disc.d7x": "心が健やかであってこそ、長生きに意味があります。認知科学と医学が協力し、記憶、動機づけ、意味が加齢とともにどう変化するかを描き、延びた年月が生きる価値のあるものであるようにします。",
  "disc.d8n": "健康科学",
  "disc.d8d": "公衆衛生、栄養、予防。すでに人類の寿命に数十年を追加してきた、人口規模のレバーです。",
  "disc.d8x": "公衆衛生は、一錠の薬もなく人類の寿命に数十年を加えました。衛生、栄養、予防です。物理学的な精度で測定すれば、これらの人口レベルのレバーは長寿のためのプログラム可能なインフラになります。",
  "disc.d9n": "医学",
  "disc.d9d": "臨床医学は長寿研究を実践に変えます。健康な年月を延ばす診断、治療、ケア。",
  "disc.d9x": "医学はあらゆる発見を実践に変えます。物理学や工学と収束することで、診断、画像、治療は、老化を早期に捉え精密に逆転させる解像度を得ます。",

  "time.eyebrow": "展望",
  "time.h2a": "初のソリューションまで",
  "time.h2b": "あと2年。",
  "time.m1t": "現在",
  "time.m1h": "サブリミナル・スケールの研究",
  "time.m1b": "深い研究と大規模計算プログラムがすでに静かに、表に出ず、物理学・AI・生物学にわたって進行しています。",
  "time.m2t": "T + 12か月",
  "time.m2h": "最初の候補介入",
  "time.m2b": "プログラム最速の検証済み成果が、シミュレーションから構造化された評価へ移ります。",
  "time.m3t": "T + 24か月",
  "time.m3h": "初のソリューション公開",
  "time.m3b": "最初のソリューションが出荷されます。抜本的な寿命延伸へ向けた複利パイプラインの始まりです。",
  "time.outro": "ご期待ください。時計はすでに動き出しています。",

  "pipe.eyebrow": "パイプライン",
  "pipe.h2a": "基礎研究から",
  "pipe.h2b": "実世界のソリューションへ。",
  "pipe.s1t": "基礎研究",
  "pipe.s1tail": "および関連領域。",
  "pipe.s2t": "モデルと発見",
  "pipe.s3t": "テクノロジー",
  "pipe.s4t": "The Lifespan Labs",
  "pipe.s4d": "より健康で、より長く、より良い生活を支える製品とサービスのキュレーションされたエコシステム。",
  "pipe.s5t": "長寿エコシステム",
  "pipe.s5tail": "および長寿志向のソリューション。",

  "back.eyebrow": "プログラム",
  "back.h2a": "まず、",
  "back.h2b": "不死の方程式。",
  "back.h2c": "そして、それが解き放つすべて。",
  "back.badge": "製品より先に証明を",
  "back.copy": "私たちの中核的な仕事は数学的です。物理学に基づく証明、不死の方程式は、生物学的時間が止められ、逆転できる理由を形式化します。私たちが作るすべてのソリューションはそこから生まれます。",
  "back.cta1": "プロジェクトに登録",
  "back.cta2": "支援する",

  "sub.eyebrow": "研究に近い場所に",
  "sub.h2a": "最新情報を購読する。",
  "sub.h2b": "コミュニティに参加する。",
  "sub.p": "研究ニュース、出版物、エコシステムの最新情報を直接お届けします。新規購読者全員に、Prime Member として初月無料のデジタルメンバーシップカードをお贈りします。",
  "sub.success.h": "コミュニティへようこそ。",
  "sub.success.p": "Prime Member のデジタルメンバーシップカードは下記のとおりです。初月無料のコピーがメールでも届きます。",
  "sub.download": "メンバーシップカードをダウンロード",
  "sub.submit": "最新情報を購読する",
  "sub.sending": "購読中...",

  "form.name": "氏名",
  "form.email": "メールアドレス",
  "form.phone": "連絡先番号",
  "form.country": "国",
  "form.city": "市区町村",
  "form.ph.name": "お名前",
  "form.ph.country": "インド",
  "form.ph.city": "ムンバイ",
  "form.error": "問題が発生しました。もう一度お試しいただくか、invest@thelifespanproject.com までご連絡ください。",
  "form.sending": "送信中...",

  "footer.desc": "人類の長寿に関する学際的研究イニシアチブ。人類の次の150年を設計しています。",
  "footer.explore": "探索",
  "footer.contact": "お問い合わせ",
  "footer.legal": "法務",
  "footer.terms": "利用規約",
  "footer.privacy": "プライバシーポリシー",
  "footer.refund": "返金ポリシー",
  "footer.faq": "よくある質問",
  "footer.partners": "テクノロジーパートナーと支援者",
  "footer.copyright": "© 2026 The Lifespan Project. All rights reserved.",
  "footer.tagline": "不死は理論上の話。150年は実現可能です。",

  "pick.title": "表示を選択",
  "pick.sub": "テーマを選んで始めましょう。ヘッダーからいつでも切り替えられます。",
  "pick.dark": "ダーク",
  "pick.dark.sub": "シネマティック",
  "pick.light": "ライト",
  "pick.light.sub": "グラデーションホワイト",

  "cookie.text": "このサイトは必須Cookieとプライバシーに配慮した分析を使用します。続行することで、私たちの",
  "cookie.accept": "了解",

  "inv.badge": "投資家向け窓口",
  "inv.h1a": "次の150年に",
  "inv.h1b": "投資する。",
  "inv.sub": "The Lifespan Project は人類の長寿に関する学際的研究イニシアチブです。あなたについてお聞かせください。投資家向けブリーフ全文をチームからお送りします。",
  "inv.perks.h": "投資家が受け取るもの",
  "inv.perk1": "投資家向けブリーフ全文と研究ロードマップ",
  "inv.perk2": "創設チームへの直通窓口",
  "inv.perk3": "データルームと技術文書（要請により）",
  "inv.perk4": "ソリューションパイプラインへの早期アクセス",
  "inv.next.h": "次のステップ",
  "inv.next.p": "お問い合わせの控えをブランド付きで即時にお送りします。その後、チームが投資家向けブリーフを持って直接ご連絡します。メール希望の方はこちら:",
  "inv.org": "組織",
  "inv.ph.org": "ファンド、機関、企業",
  "inv.interest": "ご関心の内容",
  "inv.ph.interest": "チケットサイズ、マンデート、スケジュール...",
  "inv.submit": "投資家向けブリーフを請求",
  "inv.success.h": "ありがとうございます。受け付けました。",
  "inv.success.p": "お問い合わせの控えがメールで届きます。チームよりまもなくご連絡します。",

  "join.badge": "共に取り組む",
  "join.h1a": "コラボレーターとして",
  "join.h1b": "ラボに参加。",
  "join.sub": "私たちは優れた研究者、臨床医、専門家と、インターンやコラボレーターとして、不死の方程式とそれが解き放つすべてに取り組んでいます。",
  "join.elig.h": "応募資格",
  "join.elig1": "博士号、PhD、MBBS、または MD",
  "join.elig2": "または任意分野でのダブルメジャー修士課程",
  "join.elig3": "現在、どこかで専門職として就労中",
  "join.elig4": "インド国内外で5年以上の経験",
  "join.next.h": "次のステップ",
  "join.next.p": "すべての応募は研究チームが個別に確認します。送信内容の控えが即座にメールで届き、適性があればご連絡します。",
  "join.qual": "最終学歴",
  "join.qual.select": "学歴を選択",
  "join.disc": "最も合う分野はどれですか？",
  "join.disc.select": "分野を選択",
  "join.disc.unsure": "まだ決まっていない",
  "join.spec": "専門分野",
  "join.ph.spec": "例: 量子生物学、神経学",
  "join.exp": "経験年数",
  "join.ph.exp": "最低5年",
  "join.role": "現在の役職と所属",
  "join.ph.role": "例: 研究員、CSIR",
  "join.why": "なぜ協力したいのですか？",
  "join.ph.why": "研究テーマ、出版物、取り組みたい内容...",
  "join.ph.country": "インド / 国外",
  "join.submit": "コラボレーターとして応募",
  "join.submitting": "送信中...",
  "join.success.h": "応募を受け付けました。",
  "join.success.p": "送信内容の控えがメールで届きます。研究チームがすべての応募を個別に確認します。",

  "bu.badge": "人類の長寿の科学を推進",
  "bu.h1a": "The Lifespan Project の",
  "bu.h1b": "ファウンディングメンバー",
  "bu.h1c": "になる。",
  "bu.sub": "人類の長寿の未来は、一つの領域、一つの研究室、一つの技術では築けません。研究、実験、協力、そして科学的知識の具体的なソリューションへの転換によって築かれます。あなたのメンバーシップがその歩みを支えます。",
  "bu.projline": ": 科学を研究する。",
  "bu.labsline": ": 長寿ソリューションに命を吹き込む。",

  "arch.eyebrow": "構造",
  "arch.h2a": "1つの使命。",
  "arch.h2b": "2つのエンジン。",
  "arch.proj.h": "科学的研究開発",
  "arch.labs.h": "長寿マーケットプレイス",

  "flow.1": "研究",
  "flow.2": "検証",
  "flow.3": "テクノロジー",
  "flow.4": "製品とサービス",
  "flow.5": "より長く健康な人生",

  "pos.eyebrow": "メンバーシップの意味",
  "pos.h2": "あなたは単にコンテンツを購読するのではありません。",
  "pos.p": "あなたは研究を支える創設コミュニティの一員になります。メンバーシップは、The Lifespan Project の研究、科学的作業、知識、実験、そして将来のソリューションパイプラインの継続的な発展を支えます。その対価として、ファウンディングメンバーは成長する Lifespan エコシステムにつながるデジタルファウンディングメンバーシップを受け取ります。",
  "pos.note": "メンバーシップは、科学的成果、健康上の成果、寿命の延長を保証するものではありません。",

  "eco.eyebrow": "デジタルファウンディングメンバーシップ",
  "eco.h2a": "メンバーシップは研究を超えて",
  "eco.h2b": "広がります。",
  "eco.sub": "すべてのファウンディングメンバーは、成長する Lifespan エコシステムへのデジタルメンバーシップを受け取ります。まもなく開設される The Lifespan Labs マーケットプレイスへのアクセスを含みます。",
  "eco.c1n": "健康",
  "eco.c2n": "食品と栄養",
  "eco.c3n": "バイオマーカーと検査",
  "eco.c4n": "医師と医療サービス",
  "eco.c5n": "デバイスと機器",
  "eco.c6n": "スポーツと身体",
  "eco.c7n": "ヒーリングと理学療法",
  "eco.c8n": "心と心理学",
  "eco.c9n": "心 · 体 · 魂",

  "ben.eyebrow": "ファウンディングメンバーの特典",
  "ben.h": "ファウンディングメンバーが受け取るもの",

  "mode.free": "無料",
  "mode.monthly": "月額",
  "mode.life": "生涯",
  "cad.month": "月額",
  "cad.life": "生涯",
  "cad.free": "永続",
  "cad.month.short": "月",
  "reg.intl": "インド国外",
  "reg.in": "インド",

  "plan.prime.tag": "Lifespan エコシステムへの入口。",
  "plan.prime.f1": "スキャン可能なコード付きデジタルファウンディングメンバーシップカード",
  "plan.prime.f2": "公開済みのすべての研究・コンテンツ・動画",
  "plan.prime.f3": "開設時の The Lifespan Labs へのアクセス",
  "plan.prime.f4": "メンバー特典と優待価格",
  "plan.prime.f5": "査読検討への研究提出",
  "plan.pro.tag": "Prime のすべてを生涯。さらにインナーサークルへ。",
  "plan.pro.f1": "生涯メンバーシップ、更新不要",
  "plan.pro.f2": "Pro 限定の研究発表と限定コンテンツ",
  "plan.pro.f3": "世界中の研究会議・イベントへの招待",
  "plan.pro.f4": "The Lifespan Labs での割引強化",
  "plan.pro.f5": "新製品・新サービスへの優先アクセス",
  "plan.well.tag": "科学に近い場所に。無料で。",
  "plan.well.f1": "コード付きデジタル Wellwisher メンバーシップカード",
  "plan.well.f2": "研究ニュースと最新情報",
  "plan.well.f3": "The Lifespan Labs 開設をいち早くお知らせ",

  "cta.subscribe": "ここで購読",
  "cta.free": "無料で購読",
  "cta.welllink": "Wellwisher として無料購読",

  "why.eyebrow": "理由",
  "why.h": "なぜファウンディングメンバーに？",
  "why.1t": "研究を支援する",
  "why.2t": "エコシステムにアクセス",
  "why.3t": "次に来るものを発見",
  "why.4t": "未来を共に形作る",

  "flowS.eyebrow": "つながり",
  "flowS.h": "研究からコミュニティへ",
  "flowS.n1t": "研究開発 · 科学 · 研究 · 技術",
  "flowS.n2t": "製品 · サービス · 市場 · アクセス",
  "flowS.n3t": "コミュニティ · アクセス · 参加",
  "flowS.proline": "Pro ファウンディングメンバーは、世界中で開催される厳選された Lifespan Project の研究会議、カンファレンス、エコシステムイベントに招待される場合があります。",
  "net.caption": "グローバル研究ネットワーク",

  "ck.eyebrow": "ファウンディングメンバーになる",
  "ck.h": "メンバーシップを有効化",
  "ck.submit": "安全な支払いへ進む",
  "ck.sending": "安全なチェックアウトを開いています...",
  "ck.per.month": " / 月",
  "ck.per.life": " / 生涯",
  "ck.note1": "サブスクリプションとして記録:",
  "ck.note2": "領収書と税請求書はメールで届きます。",
  "ck.invite.toggle": "招待コードをお持ちですか？",
  "ck.invite.code": "招待コード",
  "ck.invite.sending": "招待を適用しています...",
  "ck.invite.submit": "無料メンバーシップを適用",
  "ck.invite.note": "有効な招待コードをお持ちの場合、選択したプランは完全に無料になります。",
  "ck.invite.ph": "コードを入力",
  "ck.inrnote": "海外発行カードもご利用いただけます。請求は表示のルピー価格でINRにより行われます。",
  "ck.orwell": "まだ研究支援の準備ができていませんか？",

  "close.h2a": "長寿の未来を",
  "close.h2b": "見ているだけにしないでください。",
  "close.h2c": "共に築きましょう。",
  "close.p": "The Lifespan Project は研究を築いています。The Lifespan Labs はエコシステムを束ねます。ファウンディングメンバーはその歩みを可能にし、次に来るものの一部になります。",
  "close.prime": "Prime メンバーになる",
  "close.pro": "Pro メンバーになる",
  "close.or": "または",

  "res.h2a": "アイデアがありますか？",
  "res.h2b": "プロジェクトへ持ち込んでください。",
  "res.cta": "研究を提出する",

  "ww.eyebrow": "永続無料",
  "ww.title": "Wellwisher Founding Member になる",
  "ww.sub": "研究ニュースと最新情報、そしてスキャン可能なコード付きデジタル Wellwisher メンバーシップカードを即座にお届けします。",
  "ww.success.p": "ようこそ。カードは下記のとおりです。コピーがメールでも届きます。",
  "ww.submitting": "購読中...",

  "legal.notice": "この法的文書は、正確な意味を保つため英語で提供されています。",

  "ui.language": "言語",
  "ui.theme": "テーマ",
};
